/**
 * Shared URL safety check for link hrefs (web app + extension).
 * Only http/https schemes are permitted.
 */
export const isSafeLinkUrl = (raw) => {
	const url = String(raw ?? '').trim();
	if (!url) return false;
	try {
		const parsed = new URL(url);
		return parsed.protocol === 'http:' || parsed.protocol === 'https:';
	} catch {
		return false;
	}
};
